// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o8-5";
export var filledCircle = "_o8-4";
export var historyEntry = "_o8-3";
export var messageSideLeft = "_o8-1";
export var messageSideRight = "_o8-2";
export var orderTrackingCarouselWrapper = "_o8-6";
export var orderTrackingInfoContainer = "_o8-0";